var quickMacroize = require("enyo/macroize").quickMacroize,
    transformBrand,
    transformCategory;

/**
 * Takes raw incoming data from the API and applies some extra sugar.
 *
 * @param    {string}  language    The current application language
 * @param    {Object}  categories  The categories data
 * @returns  {Object}  The transformed data
 * @public
 */
exports.transformCategories = function(language, categories) {

    // Categories
    categories.map(function(category, index) {
        return transformCategory(language, category, index);
    });

    return categories;
};

/**
 * Adds links to category, transforms nested data.
 *
 * @param    {string}  language  The current application language
 * @param    {Object}  category  The category data
 * @param    {number}  index     The array index
 * @returns  {Object}  The transformed data
 * @public
 */
transformCategory = function(language, category, index) {
    // Repeater needs id's so we just use the index as id.
    category.id = index;

    // Add link to category page
    switch (category.type) {
        case "product_category":
            category.links = {
                self: quickMacroize("/{$language}/product-category/{$categorySlug}", {
                    language:     language,
                    categorySlug: category.slug
                })
            };
            break;
        case "category":
        default:
            if (category.category_type === "root") {
                category.links = {
                    self: quickMacroize("/{$language}/home", {
                        language: language
                    })
                };
            }
            else {
                category.links = {
                    self: quickMacroize("/{$language}/category/{$categorySlug}", {
                        language:     language,
                        categorySlug: category.slug
                    })
                };
            }
            break;
    }

    return category;
};

/**
 * Takes raw incoming data from the API and applies some extra sugar.
 *
 * @param    {string}  language  The current application language
 * @param    {Object}  brands    The brands data
 * @returns  {Object}  The transformed data
 * @public
 */
exports.transformBrands = function(language, brands) {

    // Brands
    brands.map(function(brand, index) {
        return transformBrand(language, brand, index);
    });

    return brands;
};

/**
 * Adds links to brand.
 *
 * @param    {string}  language  The current application language
 * @param    {Object}  brand     The brand data
 * @param    {number}  index     The array index
 * @returns  {Object}  The transformed data
 * @public
 */
transformBrand = function(language, brand, index) {
    // Repeater needs id's so we just use the index as id.
    brand.id = index;

    // Link to the corresponding page
    brand.links = {
        self: quickMacroize("/{$language}/brand/{$brandSlug}", {
            language:  language,
            brandSlug: brand.slug
        })
    };

    return brand;
};
